import React, { ComponentType, FunctionComponent } from 'react';

import { DataTableCellProps } from 'components/dataTable/dataTable.types';

import { COLUMN_IDS } from '../../keys';
import { CurrencyCell } from './currencyCell';
import { DefaultCell } from './defaultCell';

const cellComponentMap: { [key: string]: ComponentType<DataTableCellProps> } = {
  [COLUMN_IDS.TYPE]: DefaultCell,
  [COLUMN_IDS.AMOUNT]: CurrencyCell,
  [COLUMN_IDS.COUNT]: DefaultCell,
  default: DefaultCell,
};

export const TransactionCell: FunctionComponent<DataTableCellProps> = (props) => {
  const { column } = props;
  const SelectedComponent = cellComponentMap[column.id] || cellComponentMap.default;

  return <SelectedComponent {...props} />;
};
